import { render, staticRenderFns } from "./SceneControlPanel.vue?vue&type=template&id=88385596&scoped=true&"
import script from "./SceneControlPanel.vue?vue&type=script&lang=js&"
export * from "./SceneControlPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88385596",
  null
  
)

export default component.exports